import { Group, Text, Flex, Image, Stack } from '@mantine/core';
import { BanknoteIcon, CreditCardIcon } from 'lucide-react';
import classes from './PaymentMethodSelector.module.css';
import visa from '../assets/card-logos/visa.webp';
import mastercard from '../assets/card-logos/mastercard.webp';
import amex from '../assets/card-logos/amex.webp';
import discover from '../assets/card-logos/discover.webp';

export type PaymentMethodType = 'card' | 'bankAccount';

interface PaymentMethodSelectorProps {
  selectedPaymentMethod: PaymentMethodType;
  onPaymentMethodChange: (method: PaymentMethodType) => void;
  colorPalette: {
    primary: string;
    secondary: string;
    tertiary?: string;
  };
  disableAch: boolean;
  disableCreditCard: boolean;
}

export const PaymentMethodSelector = ({
  selectedPaymentMethod,
  onPaymentMethodChange,
  colorPalette,
  disableAch,
  disableCreditCard,
}: PaymentMethodSelectorProps) => {
  return (
    <Stack gap='xs'>
      <Text size='sm' fw={500}>
        Payment Method
      </Text>
      <Flex gap='md' wrap='nowrap' justify='flex-start' w='100%'>
        {!disableCreditCard && (
          <Group
            gap='xs'
            className={`${classes.acceptedPaymentMethod} ${
              selectedPaymentMethod === 'card'
                ? classes.selectedPaymentMethod
                : ''
            }`}
            onClick={() => onPaymentMethodChange('card')}
            style={{ cursor: 'pointer' }}
          >
            <CreditCardIcon
              size={18}
              strokeWidth={1.5}
              color={
                selectedPaymentMethod === 'card'
                  ? colorPalette.primary
                  : 'var(--mantine-color-gray-6)'
              }
            />
            <Text size='sm'>Card</Text>
            <Flex gap='xs' className={classes.cardBrands}>
              <Image
                src={visa}
                width={20}
                height='auto'
                alt='Visa'
                className={classes.cardLogo}
              />
              <Image
                src={mastercard}
                width={20}
                height='auto'
                alt='Mastercard'
                className={classes.cardLogo}
              />
              <Image
                src={amex}
                width={20}
                height='auto'
                alt='American Express'
                className={classes.cardLogo}
              />
              <Image
                src={discover}
                width={20}
                height='auto'
                alt='Discover'
                className={classes.cardLogo}
              />
            </Flex>
          </Group>
        )}
        {!disableAch && (
          <Group
            gap='xs'
            className={`${classes.acceptedPaymentMethod} ${
              selectedPaymentMethod === 'bankAccount'
                ? classes.selectedPaymentMethod
                : ''
            }`}
            onClick={() => onPaymentMethodChange('bankAccount')}
            style={{ cursor: 'pointer' }}
          >
            <BanknoteIcon
              size={18}
              strokeWidth={1.5}
              color={
                selectedPaymentMethod === 'bankAccount'
                  ? colorPalette.primary
                  : 'var(--mantine-color-gray-6)'
              }
            />
            <Text size='sm'>Bank Account</Text>
          </Group>
        )}
      </Flex>
    </Stack>
  );
};
